import { apiFetch } from './client';

const GROUPS = ['Admin', 'Ops', 'Delivery'];

function attrsToObject(attributes) {
  const out = {};
  (attributes || []).forEach(({ Name, Value }) => {
    out[Name] = Value;
  });
  return out;
}

function normalizeUser(raw) {
  const attrs = attrsToObject(raw.Attributes || raw.UserAttributes);
  return {
    username: raw.username || raw.Username || raw.phone_number || attrs.phone_number || raw.sub || attrs.sub,
    phone: raw.phone_number || attrs.phone_number || raw.phone,
    email: raw.email || attrs.email,
    name: raw.name || attrs.name,
    status: raw.status || raw.UserStatus,
    createdAt: raw.created_at || raw.UserCreateDate,
  };
}

async function listGroupUsers(group, token) {
  const data = await apiFetch(`/admin/groups/${group}/users`, { token });
  const list = Array.isArray(data) ? data : data?.users || data?.items || [];
  return list.map(normalizeUser);
}

export async function listStaff(token) {
  const results = await Promise.all(GROUPS.map((group) => listGroupUsers(group, token)));
  const byUsername = new Map();

  GROUPS.forEach((group, i) => {
    results[i].forEach((user) => {
      if (!user.username) return;
      const existing = byUsername.get(user.username);
      if (existing) {
        existing.groups.push(group);
      } else {
        byUsername.set(user.username, { ...user, groups: [group] });
      }
    });
  });

  return Array.from(byUsername.values());
}

export const INVITE_STAFF_ERRORS = {
  forbidden: 'You do not have permission to invite staff.',
  invalid_group: 'Pick a valid role for this staff member.',
  phone_number_required: 'Enter a phone number.',
  email_required: 'Enter a work email.',
  invalid_phone_number: 'Enter a valid 10-digit phone number.',
  invalid_email: 'Enter a valid email address.',
  email_already_registered: 'That email is already registered to another account.',
  phone_already_registered: 'That phone number is already registered to another account.',
  cognito_error: 'Could not create this account right now — try again.',
};

/** Cognito surfaces "email/phone already registered" only inside the free-text `message`. */
function inviteStaffErrorMessage(err) {
  const detail = (err?.detail || '').toLowerCase();
  if (detail.includes('email already registered')) return INVITE_STAFF_ERRORS.email_already_registered;
  if (detail.includes('phone number already registered')) return INVITE_STAFF_ERRORS.phone_already_registered;
  return (
    INVITE_STAFF_ERRORS[err?.code] ||
    err?.message ||
    'Could not send the invite. Please try again.'
  );
}

export async function inviteStaff({ phone, email, group, name }, token) {
  try {
    return await apiFetch('/admin/users/invite', {
      method: 'POST',
      token,
      body: {
        phone_number: phone,
        email,
        group,
        ...(name ? { name } : {}),
      },
    });
  } catch (err) {
    throw new Error(inviteStaffErrorMessage(err));
  }
}

export function removeStaff(member, token) {
  return apiFetch('/admin/users/offboard', {
    method: 'POST',
    token,
    body: {
      phone: member.phone || member.username,
      confirm: true,
    },
  });
}
